export default "__VITE_ASSET__20dfded1__"